export default [
  {
    path: 'crop-breed-list',
    name: 'CropBreedList',
    meta: {
      title: '种养品种'
    },
    props: route => ({ landId: Number(route.query.landId) }),
    component: () => import('@/views/productManage/PlotDetail/CropBreedList')
  },
  {
    path: 'pick-record',
    name: 'PickRecord',
    meta: {
      title: '采收记录'
    },
    props: route => ({ landId: Number(route.query.landId) }),
    component: () => import('@/views/productManage/PlotDetail/PickRecord')
  },
  {
    path: 'farm-work-record',
    name: 'FarmWorkRecord',
    meta: {
      title: '农事记录'
    },
    props: route => ({
      landId: Number(route.query.landId),
      landName: route.query.landName
    }),
    component: () => import('@/views/productManage/PlotDetail/FarmWorkRecord')
  },
  {
    path: 'agricultural-use-record',
    name: 'AgriculturalUseRecord',
    meta: {
      title: '农资使用'
    },
    props: route => ({ landId: Number(route.query.landId) }),
    component: () => import('@/views/productManage/PlotDetail/AgriculturalUseRecord')
  }
]
